import { render, staticRenderFns } from "./CongressDatesLocationCard.vue?vue&type=template&id=3f9fad1a"
import script from "./CongressDatesLocationCard.vue?vue&type=script&lang=js"
export * from "./CongressDatesLocationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports